import { useEffect } from "react";
import { onWs } from "../api/ws.js";
import { useSession } from "../state/session.js";
import { useStore } from "../store/state.js";
import { useProgression } from "./progression-state.js";
import type { HqCelebrationEvent, PowerChange } from "./progression-api.js";

export function useProgressionPushes(): void {
  const owner = useSession((s) => s.status === "authed" ? s.account?.id : null);
  useEffect(() => {
    useProgression.getState().reset(owner ?? null);
    if (!owner) return;
    if (!useProgression.getState().data) void useProgression.getState().refresh();
    const off = [
      onWs("power.changed", (e) => useProgression.getState().powerChanged(e.payload as PowerChange)),
      onWs("hq.completed", (e) => useProgression.getState().hqCompleted(e.payload as HqCelebrationEvent)),
      onWs("cosmetic.granted", () => void useStore.getState().refreshCosmetics()),
    ];
    return () => off.forEach((fn) => fn());
  }, [owner]);
}
